module.exports = __webpack_public_path__ + "img/Color 620.93c97098.jpg";